<template>
  <v-container ma-0 py-1>
    <!-- LOADING AGENCIES TREE -->
    <v-flex v-if="$loading.isLoading('fetchingAgenciesTree')">
      <h3>Cargando listado de Agencias...</h3>
      <v-progress-linear :color="colorLoading" indeterminate/>
    </v-flex>
    <!-- AGENCIES TREE -->
    <v-flex v-if="!$loading.isLoading('fetchingAgenciesTree')">

      <h3 v-if="fromSection !== 'kpi'" class="text-xs-center mb-3">Agencias</h3>

      <v-flex class="tree-container">
        <v-treeview
          v-bind="selected"
          class="px-2"
          item-key="id"
          item-text="name"
          activatable
          :items="agenciesTree"
          :active.sync="active"
          :active-class="selectedColor"
        >
        </v-treeview>
      </v-flex>

    </v-flex>
    <!-- APPLY FILTER BUTTON -->
    <v-flex v-if="showBtn">
      <v-btn
        color="primary"
        block
        @click="filterByAgencyIn"
      >
        Aplicar Filtro
      </v-btn>
    </v-flex>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { agenciesMixin } from '../mixins/agenciesMixin.js'

export default {
  name: 'agencies-tree',
  mixins: [agenciesMixin],
  props: {
    fromSection: {
      type: String,
      required: true
    },
    selectedCrud: {
      type: String,
      required: false
    },
    mapref: {
      type: Object
    }
  },
  data() {
    return {
      agencyTemp: {},
      // agencySelectedIn: null,
      match: false,
      // active: [],
      showBtn: false
    }
  },
  computed: {
    ...mapGetters(['agenciesTree']),
    selectedColor() {
      let colorRef = 'primary darken-1'
      if (this.selectedCrud === 'create') colorRef = 'teal accent-3 grey--text text--darken-3'
      else if (this.selectedCrud === 'edit') colorRef = 'amber darken-1 grey--text text--darken-3'
      // console.log(this.selectedCrud)
      // console.log(colorRef)
      return colorRef
    },
    colorLoading() {
      let colorRef = 'white'
      if (this.fromSection === 'filter') colorRef = 'primary'
      return colorRef
    },
    selected() {
      // console.log('selected agencies tree: ', this.active)

      if (!this.active.length) {
        if (this.fromSection === 'filter') {
          this.showBtn = false
        } else this.agencySelectedAction(null)
        return undefined
      }

      this.recursiveSearch(this.agenciesTree)

      // console.log('AGENCY SELECTED: ', this.agencySelectedIn)
      this.agencyIds = []
      this.agencyIds.push(this.agencySelectedIn.id)

      this.agencyTemp.name = this.agencySelectedIn.name
      this.agencyTemp.id = this.agencySelectedIn.id

      this.agencySelectedAction({
        name: this.agencySelectedIn.name,
        agencyId: this.agencySelectedIn.id
      })

      this.match = false

      // console.log('Agency selected: ', this.active[0], this.agencyTemp.id, this.agencyTemp.name)
      if (this.fromSection === 'filter') {
        // console.log(this.fromSection)
        this.recursiveSearchIn(this.agencySelectedIn)
        this.showBtn = true
      } else if (this.fromSection === 'kpi') {
        // console.log('fromSection kpi')
        this.agencySelectedIds = []
        this.recursiveSearchIds(this.agencySelectedIn)
        this.$emit('load-agency-data',
          {
            name: this.agencySelectedIn.name,
            id: this.agencySelectedIn.id,
            agencyIds: this.agencySelectedIds
          }
        )
      } else {
        this.agencySelectedAction({
          name: this.agencySelectedIn.name,
          agencyId: this.agencySelectedIn.id
        })
      }

      return this.active
    }
  },
  methods: {
    ...mapActions([
      'fetchAgenciesTreeAction',
      'filterByAgency',
      'addFilterTypeHome',
      'agencySelectedAction',
      'addVehicleData'
    ]),
    filterByAgencyIn() {
      this.agencySelectedAction({
        name: this.agencySelectedIn.name,
        agencyId: this.agencySelectedIn.id
      })
      const payload = {
        agencyIds: this.agencyIds,
        mapref: this.mapref
      }
      this.filterByAgency(payload)
    }
  },
  async created() {
    this.agencySelectedIn = null
    await this.fetchAgenciesTreeAction()
  }
}
</script>

<style scoped>
.tree-container {
  padding: 5px;
  background-color: #212121;
  border-radius: 2px;
  max-height: 350px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/AgenciesTree.vue